export const getSession = async (sessionId: string) => {
	const session = await fetch('/api/sessions/getSession', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ sessionId }),
	});

	const updatedSessionData = await session.json();
	return updatedSessionData;
};
